import { DepartmentDto } from "@dialogics/shared/dto/types"
import { ColumnDef, Row } from "@tanstack/react-table"
import { useModal } from "@component/modal"
import { ReactTailwindTable, useTable } from "@component/react-tailwind-table"
import { DepartmentForm } from "./department-form"
import { useDeleteDepartmentMutation, useGetDepartmentsQuery } from "./department-service"
import { useSelection } from "@/app/department-context"

export const DepartmentListPage = ({ organizationId }: { organizationId: number }) => {
  const { selectedDepartment, setSelectedDepartment } = useSelection()
  const { pagination, setPagination } = useTable({ defaultPageSize: 10 })
  const [deleteDepartment] = useDeleteDepartmentMutation()

  const { isOpen: isFormOpen, openModal: openForm, closeModal: closeForm, data: department } = useModal<DepartmentDto>()

  const columns: ColumnDef<DepartmentDto>[] = [
    {
      accessorKey: "title",
      header: "Название",
    },
    {
      header: "Источник данных",
      cell: ({ row }: { row: Row<DepartmentDto> }) => {
        const ds = row.original.call_data_source
        return ds ? `#${ds.id} — ${ds.type}` : "—"
      },
    },
    {
      header: "Конфигурация",
      cell: ({ row }: { row: Row<DepartmentDto> }) => {
        return row.original.organization_group?.code ?? "—"
      },
    },
    {
      id: "actions",
      cell: ({ row }: { row: Row<DepartmentDto> }) => {
        const isSelected = selectedDepartment?.id === row.original.id
        return (
          <div className="flex gap-2">
            <button
              className="btn btn-sm btn-primary"
              onClick={() => setSelectedDepartment(row.original)}
              disabled={isSelected}
            >
              {isSelected ? "Выбрано" : "Выбрать"}
            </button>
            <button className="btn btn-sm btn-secondary" onClick={() => openForm(row.original)}>
              Редактировать
            </button>
            <button
              className="btn btn-sm btn-error btn-outline"
              onClick={() => {
                if (confirm(`Удалить департамент «${row.original.title}»?`)) {
                  deleteDepartment(row.original.id)
                }
              }}
            >
              Удалить
            </button>
          </div>
        )
      },
    },
  ]

  return (
    <div className="max-w-7xl mx-auto bg-white dark:bg-base-200 p-6 sm:p-8 rounded-lg shadow-sm">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl">Департаменты</h1>
        <button className="btn btn-primary" onClick={() => openForm()}>
          Создать департамент
        </button>
      </div>
      <ReactTailwindTable
        query={useGetDepartmentsQuery}
        queryParams={{ organizationId }}
        columns={columns}
        pagination={pagination}
        setPagination={setPagination}
      />
      <DepartmentForm
        isOpen={isFormOpen}
        onClose={closeForm}
        department={department ?? undefined}
        organizationId={organizationId}
      />
    </div>
  )
}
